// Topic subscriber count increments for a newly created contact.
// Uses the saved contact's active arrays; tempTags are pending, not counted.
export const buildCreationTopicCounts = ({ emailTags, textTags } = {}) => {
  const emailTopicCounts = {};
  const textTopicCounts = {};
  const totalTopicCounts = {};

  for (const topic of new Set(emailTags || [])) {
    emailTopicCounts[topic] = 1;
    totalTopicCounts[topic] = 1;
  }
  for (const topic of new Set(textTags || [])) {
    textTopicCounts[topic] = 1;
    totalTopicCounts[topic] = 1;
  }

  return { totalTopicCounts, emailTopicCounts, textTopicCounts };
};
